import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import LoadingSpinner from '../../components/forms/LoadingSpinner';
import ContentList from '../../components/homeuser/ContentList';
import SpecialCarousel from './SpecialCarousel';
import { fetchCmsSpecial } from '../../action-creators/specials';
import { getNavType } from '../../utils/getNavType';

const withName = (p, c) => {
  p[c.name] = c;
  return p;
};

export class SpecialView extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
    this.fetchData = this.fetchData.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    const { node, special } = this.props;
    const data = { node, special };
    data.type = getNavType();
    // clear node if we got just special
    if (node === special) {
      data.node = '';
    }

    this.props.fetch(data).then(() => {
      this.setState({ loading: false });
    });
  }

  render() {
    const { loading } = this.state;
    if (loading) {
      return <LoadingSpinner />;
    }
    const [specialMain, specialFoot] = this.props.specials;
    const topCarousel = specialMain?.components?.component?.reduce(withName, {});
    const bottomCarousel = specialFoot?.components?.component?.reduce(
      withName,
      {},
    );
    const carousel = {
      name: bottomCarousel?.carrousel?.name,
      type: bottomCarousel?.carrousel?.type,
      id: bottomCarousel?.carrousel?.properties?.id,
      url: bottomCarousel?.carrousel?.properties?.url,
    };

    const specialCarousel = Object.assign(
      {},
      topCarousel?.carrousel?.properties,
      {
        name: topCarousel?.carrousel?.name,
        type: topCarousel?.carrousel?.type,
        special: true,
      },
    );

    const background = {
      lg: {
        backgroundImage: `url(${topCarousel?.background?.properties?.imglarge})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '40px',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        inset: 0
      },
      sm: {
        backgroundImage: `url(${
          topCarousel?.background?.properties?.imgextrasmall
        })`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        inset: 0
      },
    };

    return (
      <div>
        <section
          className="section-0 section-Cinta-1 section-especial section-especial03"
          style={{ position: 'relative' }}
        >
          <MediaQuery query="(max-width: 910px)">
            <div style={background?.sm} />
          </MediaQuery>

          <MediaQuery query="(min-width: 911px)">
            <div style={background?.lg} />
          </MediaQuery>
          <div className="container2" />
          <SpecialCarousel
            carouselData={specialCarousel}
            titleDefault={topCarousel?.header?.properties?.large}
          />
        </section>

        <section className="section-1 section-carrousel">
          <ContentList
            carrouselData={carousel}
            url={carousel.url}
            titleDefault={bottomCarousel?.header?.properties?.large}
          />
        </section>
      </div>
    );
  }
}

SpecialView.propTypes = {
  node: PropTypes.string,
  special: PropTypes.string,
  specials: PropTypes.array,
  fetch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  specials: state.specials.modules,
});

const mapDispatchToProps = {
  fetch: fetchCmsSpecial,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SpecialView);
